/** POST /Api/AutomationApi/pennyDrop (apply-new) */
export const buildBankVerificationPayload = ({
  leadId,
  custBankingId,
  bankName,
  ifsc,
  holderName,
  accountNumber,
  accountType = "Savings",
  paymentMode = "IMPS",
}) => {
  const lead = String(leadId || "").trim();
  const bankingId = String(custBankingId || "").trim();
  const account = String(accountNumber || "").replace(/\D/g, "");

  return {
    ...(lead
      ? { lead_id: /^\d+$/.test(lead) ? Number(lead) : lead }
      : {}),
    ...(bankingId
      ? {
          cust_banking_id: /^\d+$/.test(bankingId)
            ? Number(bankingId)
            : bankingId,
        }
      : {}),
    bank_name: String(bankName || "").trim(),
    ifsc_code: String(ifsc || "").trim().toUpperCase(),
    beneficiary_name: String(holderName || "").trim(),
    account,
    confirm_account: account,
    account_type: accountType || "Savings",
    payment_mode: paymentMode || "IMPS",
  };
};

export const isBankVerificationSuccess = (data) => {
  if (!data) return false;
  if (typeof data === "string") {
    const text = data.toLowerCase();
    return text.includes("success") || text.includes("verified");
  }
  if (typeof data !== "object") return false;

  if (
    data.recommendedAction === "AC_TXN_FAILED" ||
    String(data.recommendedAction || "").includes("FAILED")
  ) {
    return false;
  }

  if (data.desc && data.status !== true && data.status !== 1 && data.status !== "1") {
    return false;
  }

  if (data.status === true || data.status === 1 || data.status === "1") return true;
  if (data.success === true || data.Success === true) return true;
  if (data.verified === true || data.is_verified === true) return true;

  const nested = data.data || data.Data || data.result || data.response;
  if (nested && typeof nested === "object") {
    if (isBankVerificationSuccess(nested)) return true;
  }

  const message = String(
    data.message || data.Message || data.msg || data.error || data.desc || ""
  ).toLowerCase();
  if (
    message.includes("verified successfully") ||
    message.includes("verification successful") ||
    message.includes("account verified") ||
    message === "success"
  ) {
    return true;
  }

  return false;
};

export const getBankVerificationMessage = (
  data,
  fallback = "Bank account verification failed. Please check your details."
) => {
  if (!data) return fallback;
  if (typeof data === "string") return data.trim() || fallback;

  const nested = data.data || data.Data || data.result;
  const nestedMsg =
    nested && typeof nested === "object"
      ? nested.desc ||
        nested.description ||
        nested.message ||
        nested.Message ||
        nested.error
      : "";

  const raw = String(
    data.desc ||
      data.description ||
      data.message ||
      data.Message ||
      data.msg ||
      data.error ||
      data.Error ||
      nestedMsg ||
      ""
  ).trim();

  if (/maximum attempts reached/i.test(raw)) {
    return "Maximum attempts reached";
  }

  return raw || fallback;
};

export const getBankVerificationBankingId = (data) => {
  if (!data || typeof data !== "object") return "";
  const nested = data.data || data.Data || {};
  return String(
    nested.cust_banking_id ||
      nested.banking_id ||
      data.cust_banking_id ||
      ""
  );
};
